export default __webpack_public_path__ + "/dist/images/2450674.4736387466bcec8b04d2328c28a7f4e0.png";